<template>
    <div class="homepageSlideshow">
        <vueper-slides
            :fade="window.width > 576 ? true : false"
            :arrows="true"
            :bullets="true"
            :pauseOnHover="false"
            :touchable="window.width > 576 ? false : true"
            :fixed-height="`${slideshowHeight}px`"
            :arrows-outside="true"
            :bullets-outside="true"
            :dragging-distance="70"
            ref="myVueperSlides"
            @slide="currentIndex = $event.currentSlide.index"
            class="slideshow_container">
            <vueper-slide
                v-for="(slide, i) in slidesData"
                :key="i"
                class="slide_container">
                <template v-slot:content>
                    <div class="slide">
                        <div v-if="slide.show_video_homepage_slideshow" class="video-container">
                            <div class='youtube-embed-container'>
                                <iframe :src="'https://www.youtube.com/embed/'+ slide.video_section_url+'?controls=0&rel=0'" frameborder='0' allowfullscreen :height="adaptiveHeight" :width="adaptiveHeight"></iframe>
                            </div>
                        </div>
                        <div v-else class="img-container">
                            <img :src="slide.show_case_image.data.full_url" :alt="data[currentIndex].company_name" :width="adaptiveHeight" :height="adaptiveHeight">
                        </div>
                        <div class="content desktop_content">
                            <p class="small_title text">
                                {{data[currentIndex].company_name}} / {{data[currentIndex].subtitle}}
                            </p>
                            <p class="description" v-html="data[currentIndex].short_description">
                            </p>
                        </div>
                    </div>
                </template>
            </vueper-slide>
        </vueper-slides>
        <div class="content mobile_content">
            <p class="small_title text">
                {{data[currentIndex].company_name}} / {{data[currentIndex].subtitle}}
            </p>
            <p class="description" v-html="data[currentIndex].short_description">
            </p>
        </div>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'

export default {
    name: "HomepageSlideshow",
    components: { VueperSlides, VueperSlide },
    props:{
        data:{
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            currentIndex: 0,
            window: {
                width: 0,
                height: 0
            },
        }
    },
    methods:{
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    },
    computed: {
        adaptiveHeight: function(){
            if(this.window.width > 938){
                return 500;
            } if (this.window.width < 576){
                return this.window.width;
            } else {
                return this.window.width * 0.4;
            }
        },
        slideshowHeight: function(){
            if(this.window.width > 938){
                return 620;
            } if (this.window.width < 576){
                return this.window.width;
            } else {
                return this.window.width * 0.4 + 80;
            }
        },
        slidesData: function(){
            if (this.window.width < 576) {
                return this.data.filter((slide) => {
                    return !slide.show_video_homepage_slideshow
                })
            }
            return this.data;
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
    
}
</script>

<style lang="scss" scoped>
.homepageSlideshow{
    display: block;
    margin: 40px 0 10px;
}
.slideshow_container{
    padding: 0 90px;
    width: 100%;
}
.slide_container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.slide{
    display: flex;
    align-items: center;
    justify-content: center;
    .img-container{
        img{
            display: block;
            object-fit: cover;
        }
    }
    .content{
        width: 40%;
        max-width: 400px;
        margin-left: 3rem;
    }
}
.text{
    text-transform: uppercase;
    color: #000;
}
.description{
    padding-right: 3rem;
}

.mobile_content{
    display: none;
}

@media (max-width: $mobile) {
    p{
        margin: 0;
    }
    .homepageSlideshow{
        flex-wrap: wrap;
        margin: 77px 0 30px;
    }
    .slideshow_container{
        padding: 0;
        width: 100%;
    }
    .slide_container{
        margin: 0 auto;
        justify-content: unset;
        align-items: unset;
    }
    .slide{
        flex-wrap: wrap;
        justify-content: unset;
        align-items: unset;
        .content{
            width: 100%;
            margin: 77px 2rem 0;
            max-width: unset;
        }
    }
    .small_title{
        margin: 0 0 2rem;
    }
    .description{
        padding-right: 0;
    }
    .desktop_content{
        display:none;
    }
    .mobile_content{
        display: block;
        margin: 4rem 2rem 0;
        text-align: center;
    }
}
</style>

<style lang="scss">
.homepageSlideshow{
    .vueperslides__bullets{
        bottom: 30px;
        .default {
            width:8px;
            height:8px;
            border-radius: 8px;
            color: #000;
            background-color: #000;
            box-shadow: none;
        }
    }
    .vueperslides__bullet--active{
        .default {
            width:8px;
            height:8px;
            border-radius: 8px;
            color: #b93f5f;
            background-color: #b93f5f;
            border-width: unset;
            box-shadow: none;
        }
    }
    .vueperslides__arrows--outside .vueperslides__arrow--prev{
        left: -4.5em;
    }
    .vueperslides__arrows--outside .vueperslides__arrow--next{
        right: -4.5em;
    }
    .vueperslides--fixed-height.vueperslides--bullets-outside{
        margin-bottom: 20px;
    }
}

@media (max-width: $tablet) {
    .homepageSlideshow{
        .vueperslides--fixed-height { 
            height: 400px;
        }
    }
}

@media (max-width: $mobile) {
    .homepageSlideshow{

        .vueperslides__bullets{
            bottom: -10px;
        }
        .vueperslides__arrows--outside{
            display: none;
        }
    }
}
</style>